"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarIcon20Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.StarIcon20Solid = forwardRef_1.forwardRef('StarIcon20Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { d: "M9.139 1.7c.325-.756 1.397-.756 1.722 0l2.03 4.713 5.11.474c.819.076 1.15 1.095.532 1.637l-3.856 3.387 1.129 5.006c.18.803-.686 1.433-1.394 1.013L10 15.31l-4.412 2.62c-.708.42-1.575-.21-1.394-1.013l1.129-5.006-3.856-3.387C.85 7.981 1.18 6.963 2 6.887l5.11-.474L9.14 1.7Z" })));
});
